<app-llc-borrowers-sync
	[transaction]="transaction"
	(next)="next()"
></app-llc-borrowers-sync>
